var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeechBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.663,
    height: 20.93,
    viewBox: "0 0 23.663 20.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".speech-a{fill:#fff;}.speech-b{clip-path:url(#speech-a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "speech-a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "speech-a",
    width: 23.663,
    height: 20.93
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "speech-b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "speech-a",
    d: "M19.719,5.916A5.916,5.916,0,0,0,13.8,0H5.916A5.912,5.912,0,0,0,3.944,11.487V16.17L8.3,11.832h5.5a5.916,5.916,0,0,0,5.916-5.916",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "speech-a",
    d: "M36.453,22.551a7.5,7.5,0,0,1-6.873,4.515H26.051a4.337,4.337,0,0,0,4.318,3.944h2.339l3.577,3.577V30.842a4.335,4.335,0,0,0,.168-8.291",
    transform: "translate(-15.777 -13.657)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speech-bubble.a6dcda95.svg";
export { ForwardRef as ReactComponent };